import axios from "axios";
import { queryParams } from "../../../../utils/queryParams";

const instance = axios.create({
  baseURL: queryParams.apiVersion + "pages/attendance/booking_chart/"
});

export const api = {
  getFilters(params) {
    return instance.post("get_filters", params);
  },
  getChart(params) {
    return instance.post("values", params);
  },
  getTable(params) {
    return instance.post("table", params);
  }
};
